import { render } from "./InquiryList.vue?vue&type=template&id=8ae0185e"
import script from "./InquiryList.vue?vue&type=script&lang=js"
export * from "./InquiryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__